/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IGetPricingInformationResponse } from './progressive-proxy-files/ProgressiveDataServiceEntities.g';

/**
 * ProgressiveSetPricingInfo Input Action
 */
export class ProgressiveSetPricingInfoInput implements Msdyn365.IActionInput {
    // ProgressiveSetPricingInfo Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `ProgressiveSetPricingInfo`;
    public getCacheObjectType = () => 'ProgressiveSetPricingInfo';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// ProgressiveSetPricingInfo Create a data model here or import one to capture the response of the action
export interface IProgressiveSetPricingInfoData {
    pricingInfo: IGetPricingInformationResponse;
    leaseId: string;
    approvalAmount: string;
    applyProgressive: boolean;
    contractESignUrl: string;
    cartId: string;
}

/**
 * ProgressiveSetPricingInfo Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new ProgressiveSetPricingInfoInput();
};
/**
 * ProgressiveSetPricingInfo Use this function to call your action and process the results as needed
 */
async function action(input: ProgressiveSetPricingInfoInput, ctx: Msdyn365.IActionContext): Promise<IProgressiveSetPricingInfoData> {
    return { pricingInfo: { CRTStatus: false, IsNoContent: true }, leaseId: '', approvalAmount: '', applyProgressive: false, contractESignUrl: '', cartId: '' };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IProgressiveSetPricingInfoData>>action,
    // ProgressiveSetPricingInfo: Give your data action a unique id
    id: 'ProgressiveSetPricingInfo',
    input: createInput
    // ProgressiveSetPricingInfo: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
